// extracted by mini-css-extract-plugin
export default {"wrapper":"IqosQuizGame_wrapper__sCidC","endCard":"IqosQuizGame_endCard__0xh63","text":"IqosQuizGame_text__Odsx-"};